
import Vue from "vue"

const LANG_STYLES: Record<string, { bg: string; color: string }> = {
  ru: { bg: "var(--color-green)", color: "#FFFFFF" },
}

export default Vue.extend({
  props: {
    languages: { type: Array as VuePropType<string[]>, default: () => [] },
    language: { type: String, default: "" },
  },

  computed: {
    hasTranslation (): boolean {
      return this.languages.length >= 2
    },

    tooltip (): string {
      if (!this.language) return ""

      const key = `programLanguages.${this.language}`
      const label = this.$t(key) as string

      return label === key ? "" : label
    },
  },

  methods: {
    langStyle (lang: string) {
      const s = LANG_STYLES[lang]
      return s
        ? { backgroundColor: s.bg, color: s.color }
        : { backgroundColor: "#FCC000", color: "var(--color-gray-4)" }
    },
  },
})
